import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <span>Built with ❤️ using React &amp; plain CSS</span>
        <span>© {new Date().getFullYear()} Finance Dashboard</span>
      </div>
    </footer>
  );
}

export default Footer;
